export enum SupportedLanguages {
  EN = "en",
  HE = "he"
}

export interface siteNavigationDict {
  bookConsultation: { name: string; description: string };
  aiAdvisor: { name: string; description: string };
  docBrain: { name: string; description: string };
  industries: { name: string; description: string };
  fromNews: { name: string; description: string };
  aiSystemDevelopment: { name: string; description: string };
  customSoftwareDevelopment: { name: string; description: string };
}

export type Dictionary = {
  siteNavigation: siteNavigationDict,
  nav: headerDict,
main: {
    hero: {
      title: string;
      subtitle: string;
      innovatingVision: {
        title: string;
        subtitle: string;
      }
      cta: string;
    },
    heroAI?: {
      eyebrow?: string;
      prompt?: {
        placeholder?: string;
        cta?: string;
        hint?: string;
        suggestions?: string[];
      };
      personalizedPath?: {
        thinking?: string;
        servicesTitle?: string;
        bookCta?: string;
        capture?: {
          title?: string;
          description?: string;
          namePlaceholder?: string;
          emailPlaceholder?: string;
          submit?: string;
          success?: string;
          error?: string;
        };
      };
    },
    simpleExplainer?: {
      eyebrow?: string;
      title?: string;
      items?: Array<{
        title: string;
        description: string;
        example: string;
      }>;
    },
    chatWidget: ChatWidgetDict,
    aiIntegration: {
      integration: Array<{
        title: string
        description: string
        image: string
        image2?: string
        href?: string
      }>
      button: string
    },
    expertise: {
      title: string
      subtitle: string
      ai: {
        title: string
        description: string 
      },
      development: {
        title: string
        description: string
      },
      studio: {
        title: string 
        description: string
      }
    },
    footerLogos: {
      title: string
    },
    achievements: AchievementCardDict,
    stats: StatsDict,
    caseStudies: CaseStudiesDict,
    industries?: { title?: string; subtitle?: string },
    testimonials: testimonialSectionDict,
    founderProof?: {
      title?: string
      subtitle?: string
      readMore?: string
      note?: string
      items?: Array<{
        quote: string
        role: string
        company: string
        metric: string
        slug?: string
      }>
    },
    openaiPartner?: {
      eyebrow?: string
      title?: string
      subtitle?: string
      reasons?: Array<{ title: string; description: string }>
      cta?: string
    },
    howItWorks?: {
      title?: string
      steps?: Array<{ title: string; description: string }>
    },
    faq: FAQDict,
    cta: {
      title: string
      description: string
    },
    contactForm: {
      title: string
      description: string
      fields: {
        firstName: string
        lastName: string
        email: string
        phone: string
        message: string
      }
      submit: string
      success: string
      error: string
      booking: string
      privacyPolicy: {
        prefix: string
        privacyText: string
        suffix: string
      }
    } 
    partners: {
      title: string
      description: string;
    },
    title: string,
    description: string
  },
  footer: footerDict,
  industries: IndustriesDict,
  askAi: AskAiDict,
  contactUs: {
    success: ContactUsActionDict,
    failed: ContactUsActionDict,
  },
  docbrain: {
    hero: heroDict,
    statsSection: statsSectionDict,
    testimonialSection: testimonialSectionDict,
    workflow: workflowSectionDict,  
    features: featuresSectionDict,
    growBusiness: GrowBusinessDict,
    faqSection: faqSectionDict,
  },
  privacyPolicy: {
    title: string;
    sections: Array<{
      title: string;
      content: Array<{
        type: "text" | "list";
        value: string | string[];
      }>;
    }>;
  },
  blog: BlogDict,
  calendar: {
    consultationTitle: string
    docbrainTitle: string
    subtitle: string
    selectDateTime: string
   
    noAvailability: string
    checkNextAvailability: string
    clientDetailsTitle: string
    labels: {
      name: string
      email: string
      phone: string
      message: string
      subject: string
      privacyPolicy?: {
        prefix: string
        privacyText: string
        suffix: string
      }
    }
    placeholders: {
      name: string
      email: string
      phone: string
      message: string
    }
    bookingDetailsTitle: string
    
    bookingNow: string
    onlineMeeting: string
    duration: string
    availableOnline: string
    bookingSuccess: {
      title: string
      subtitle: string
      button: {
        home: string
      }
    }
    bookingFailed: {
      title: string
      subtitle: string
      errorMessage: string
      buttons: {
        tryAgain: string
      }
    }
  },
  news: newsPageDict;
  caseStudy: CaseStudyDict;
  landingPage: LandingPageDict;
  technologyDecisionReview: TechnologyDecisionReviewDict;
  personaLandingPage?: PersonaLandingPageDict;
}

export interface newsPageDict {
    title: string;
    subtitle: string;
    article_title: string;
    article_subtitle: string;
    article_content_part1: string;
    article_content_part2: string;
    article_link_text: string;
    cta_title: string;
    cta_button_text: string;
}

export interface heroDict {
  title: string
  subtitle: string
  image: string
  cta: string
}

export interface statsSectionDict {
  title: string
  spanTitle: string
  stats: Array<{
    value: string
    label: string
    suffix: string
  }>
}

export interface testimonialSectionDict {
  title: string
  subtitle?: string
  testimonials: Array<Testimonial>
  cta?: string
}

export interface Testimonial {
  text: string
  author: string
  role: string
}

export interface workflowSectionDict {
  sectionTitle: string
  steps: Array<{
    title: string
    description: string
  }>
  cta: string
}


export interface featuresSectionDict {
  benefitsTitle: string
  benefitsSubtitle: string
  benefits: Array<{
    title: string
    description: string
  }>
  cta: string
}

export interface faqSectionDict {
  title: string
  faqs: Array<{
    question: string
    answer: string
  }>
}

export interface GrowBusinessDict {
  title: string;
  cta: string;
}

export interface FAQDict {
  title: string;
  subtitle: string;
  items: Array<{
    question: string;
    answer: string;
    links?: Array<{ label: string; href: string }>;
  }>;
}

export interface headerDict {
  services: string
  aiSystems: string
  customSoftware?: string
  caseStudies: string
  industries: string
  products: {
    title: string
    productOne: string
    productThree: string
    productFour: string
  }
  aiAdvisor: string
  aiBlueprint: string
  fromNews: string
  blog: string
  button: string
  sideButton: string
}
export interface AskAiDict {
  eyebrow: string
  title: string
  description: string
  buttonPrefix: string
}
export interface footerDict {
  description: string
  services: string
  company: string
  products: string
  industries: string
  chatAdsAi: string
  caseStudies: string
  aiSystems?: string
  customSoftware?: string
  aiAdvisor: string
  aiBlueprint?: string
  docBrain: string
  fromNews: string
  blog: string
  info: {
    title: string
    address: string
    privacyPolicy: string
  }
  contact: {
    title: string
    email: string
    subtitle: string
    label: string
  }
  privacyPolicy: {
    prefix: string
    privacyText: string
    suffix: string
  }
  copyright: string
}
export interface BlogDict {
  title: string;
  subtitle: string;
  readMore: string;
  backBtn: string;
  writtenBy: string;
  minRead: string;
  moreArticlesTitle: string;
  contactBlog:  {
    title: string
    fields: {
      fullName: string
      email: string
      phone: string
      message: string
    }
    submit: string
  };
}

export interface BlogPost {
  id: string;
  authorId: string;
  isMain: boolean;
  title: {
    en: string;
    he: string;
  };
  seoTitle?: {
    en?: string;
    he?: string;
  };
  date: string;
  updatedAt?: string;
  lastReviewedAt?: string;
  topics?: string[];
  industries?: string[];
  keyTakeaways?: {
    en: string[];
    he: string[];
  };
  faq?: {
    en?: Array<{ q: string; a: string }>;
    he?: Array<{ q: string; a: string }>;
  };
  excerpt: {
    en: string;
    he: string;
  };
  topContent: {
    en: string;
    he: string;
  };
  bottomContent: {
    en: string;
    he: string;
  };
}
export interface MainPost {
  id: string;
  authorId: string;
  isMain: boolean;
  title: {
    en: string;
    he: string;
  };
  date: string;
  topContent: {
    en: string;
    he: string;
  };
  bottomContent: {
    en: string;
    he: string;
  };
}


export interface ChatWidgetDict {
  title: string
  subtitle: string
  placeholder: string
}

export interface AchievementCardDict {
  title: string;
  revenue: CardDict,
  solutions: CardDict,
  innovation: CardDict,
  focus:CardDict
};

export interface CardDict {
  title: string
  description: string
}

export interface StatsDict {
  title: string 
  items: Array<{
    value: string
    label: string
    unit: string
  }>
}

export interface ContactUsActionDict  {
  title: string
  description: string
  button: string
}

export interface CaseStudy {
  image: string;
  title: string;
  subtitle?: string;
  description?: string;
  /** Short outcome chip shown on the card, e.g. "~1M events/month". */
  metric?: string;
  /** Case-study page slug; when present the card links to the full story. */
  slug?: string;
  /** Live industry slug the card links to. */
  industry?: string;
}

export interface CaseStudiesDict {
  title: string;
  subtitle: string;
  readMore: string;
  caseStudies: CaseStudy[];
}

export interface CaseStudyDict {
  title: string;
  subtitle: string;
  backButton: string;
  gallery: {
    title: string;
    subtitle: string;
  };
  challenge: {
    title: string;
    description: string;
  };
  solution: {
    title: string;
    description: string;
  };
  keyFeatures: {
    title: string;
    subtitle: string;
  };
  technologies: {
    title: string;
    subtitle: string;
  };
  stats: {
    title: string;
  };
  results: {
    title: string;
  };
  testimonial: {
    title: string;
  };
  visitWebsite: string;
  nextProject: string;
  contactCta: {
    title: string;
    subtitle: string;
    button: string;
  };
}

export interface TechnologyDecisionReviewDict {
  meta: {
    title: string;
    description: string;
  };
  hero: {
    title: string;
    titleSecondary: string;
    subtitle: string;
    cta: string;
  };
  whoIsThisFor: {
    title: string;
    items: string[];
  };
  whatIsThis: {
    title: string;
    description: string;
    explanation: string;
  };
  howItWorks: {
    title: string;
    steps: Array<{
      number: string;
      title: string;
      description: string;
    }>;
  };
  whyCompaniesDoThis: {
    title: string;
    points: Array<{
      title: string;
      description: string;
    }>;
  };
  cta: {
    title: string;
    subtitle: string;
    primaryButton: string;
    secondaryButton: string;
    email: string;
  };
}

export interface LandingPageDict {
  hero: {
    title: string;
    subtitle: string;
  };
  form: {
    title: string;
    subtitle: string;
    fields: {
      companyName: string;
      companySize: string;
      challenge: string;
      businessEmail: string;
    };
    companySizes: {
      '1-5': string;
      '6-20': string;
      '21-50': string;
      '51-200': string;
      '200+': string;
    };
    budgets?: {
      '20,000-50,000': string;
      '50,000-100,000': string;
      '100,000-200,000': string;
      '200,000+': string;
    };
    placeholders: {
      companyName: string;
      companySize: string;
      challenge: string;
      businessEmail: string;
    };
    submit: string;
    submitting: string;
  };
  thankYou: {
    unqualified: {
      title: string;
      message: string;
      subtitle: string;
      button: string;
    };
    qualified: {
      title: string;
      message: string;
      subtitle: string;
      button: string;
    };
  };
  booking: {
    title: string;
    subtitle: string;
    close: string;
  };
  validation: {
    companyNameRequired: string;
    companySizeRequired: string;
    challengeRequired: string;
    challengeMinLength: string;
  };
}

export interface PersonaLandingPageDict {
  form: {
    title: string;
    subtitle: string;
    fields: {
      role: string;
      companyName: string;
      companyWebsite: string;
      companySize: string;
      whatToBuild: string;
      budget: string;
      urgency: string;
      email: string;
      phone: string;
    };
    companySizes: Record<string, string>;
    urgencies: Record<string, string>;
    placeholders: Record<string, string>;
    submit: string;
    submitting: string;
    agreeToTerms: string;
  };
  validation: {
    companyNameRequired: string;
    companySizeRequired: string;
    whatToBuildRequired: string;
    budgetRequired: string;
    urgencyRequired: string;
    emailRequired: string;
    emailInvalid: string;
    termsRequired: string;
  };
  cta: {
    bookCall: string;
    whatsapp: string;
    scrollToForm: string;
  };
  whyPalmidos: {
    title: string;
    subtitle: string;
    eliteTalent: {
      title: string;
      description: string;
    };
    fixedPrice: {
      title: string;
      description: string;
    };
    fastDelivery: {
      title: string;
      description: string;
    };
  };
  howItWorks: {
    title: string;
  };
  testimonials: {
    title: string;
  };
  socialProof: {
    title: string;
  };
}

export interface IndustriesDict {
  breadcrumbHome: string;
  breadcrumbIndustries: string;
  bookCall: string;
  whatsapp: string;
  whatsappMessage: string;
  problems: { eyebrow: string; title: string };
  expertise: { title: string; titleFor: string; subtitle?: string };
  caseStudy: {
    eyebrow: string;
    title: string;
    inProgress: string;
    responsibilities: string;
    technologies: string;
    stack: string;
    aboutClient: string;
    builtFor: string;
    buildingFor: string;
    ownTitle: string;
    ownEyebrow: string;
    ownBuilt: string;
    moreCases: string;
    visitSite: string;
  };
  solutions: { eyebrow: string; title: string; segments: string };
  systems: { title: string };
  faq: { title: string; subtitle: string };
  related: { title: string };
  contactTitle: string;
}

// Next passes route params as plain strings; pages validate `lang` against the
// supported locales before relying on it.
export type LangRouteParams = { lang: SupportedLanguages } & Record<string, string>;
